import IconType from "@/types/Icon.type";
import IconPetsGroup from "@Icons/ticket/amenities/pets/IconPetsGroup";
import IconMealsGroup from "@Icons/ticket/amenities/meals/IconMealsGroup";

function IconTicketAmenityGroup(props: IconType) {
    const {title} = props

    const matchedAmenityGroups = {
        IconPetsGroup,
        IconMealsGroup,
    }

    const AmenityGroupIcon = matchedAmenityGroups[title]

    if (AmenityGroupIcon) {
        return <AmenityGroupIcon {...props}/>
    }

    return null
}

export default IconTicketAmenityGroup